import ClientId from '../ClientId';

const didSetNativeAppCapabilities: Partial<Record<ClientId, string>> = {
  [ClientId.HOME_UI]: 'home-set-app-capabilities',
  [ClientId.SRP_UI]: 'srp-set-app-capabilities',
  [ClientId.VDP_UI]: 'vdp-set-app-capabilities'
};

export default didSetNativeAppCapabilities;
